import { McpToolInput } from './mcp-tool-input'
import { McpToolOutput } from './mcp-tool-output'

export enum McpToolName {
  DescribeMcpInstructions = 'describe_mcp_instructions',
  AssignContactTag = 'assign_contact_tag',
  CreateContact = 'create_contact',
  GetContact = 'get_contact',
  GetContacts = 'get_contacts',
  RemoveContact = 'remove_contact',
  RemoveContactTag = 'remove_contact_tag',
  UpdateContact = 'update_contact',
  GetContactFields = 'get_contact_fields',
  CreateTag = 'create_tag',
  GetTag = 'get_tag',
  GetTags = 'get_tags',
  RemoveTag = 'remove_tag',
  UpdateTag = 'update_tag',
  CreateAutomationRule = 'create_automation_rule',
  DeleteAutomationRule = 'delete_automation_rule',
  GetAutomationRule = 'get_automation_rule',
  GetAutomationRules = 'get_automation_rules',
  UpdateAutomationRule = 'update_automation_rule',
  CreateNewsletter = 'create_newsletter',
  DeleteNewsletter = 'delete_newsletter',
  GetNewsletter = 'get_newsletter',
  GetNewsletterExcludedTags = 'get_newsletter_excluded_tags',
  GetNewsletterIncludedTags = 'get_newsletter_included_tags',
  GetNewsletterSchedule = 'get_newsletter_schedule',
  GetNewsletterStatistics = 'get_newsletter_statistics',
  GetNewsletterStatisticsList = 'get_newsletter_statistics_list',
  GetNewsletters = 'get_newsletters',
  SendNewsletter = 'send_newsletter',
  SendTestNewsletter = 'send_test_newsletter',
  SetNewsletterExcludedTags = 'set_newsletter_excluded_tags',
  SetNewsletterIncludedTags = 'set_newsletter_included_tags',
  SetNewsletterSchedule = 'set_newsletter_schedule',
  UpdateNewsletter = 'update_newsletter',
  CreateCampaign = 'create_campaign',
  CreateCampaignStep = 'create_campaign_step',
  DeleteCampaign = 'delete_campaign',
  DeleteCampaignStep = 'delete_campaign_step',
  GetCampaign = 'get_campaign',
  GetCampaignStep = 'get_campaign_step',
  GetCampaignStepStatistics = 'get_campaign_step_statistics',
  GetCampaignStepStatisticsList = 'get_campaign_step_statistics_list',
  GetCampaignSteps = 'get_campaign_steps',
  GetCampaigns = 'get_campaigns',
  SendTestCampaignStep = 'send_test_campaign_step',
  UpdateCampaign = 'update_campaign',
  UpdateCampaignStep = 'update_campaign_step',
  DescribeMailingHtmlGuide = 'describe_mailing_html_guide',
  DescribeMailingJsonSchema = 'describe_mailing_json_schema',
  GetAutomationEmailStatisticsOverview = 'get_automation_email_statistics_overview',
  GetCampaignStepStatisticsOverview = 'get_campaign_step_statistics_overview',
  GetNewsletterStatisticsOverview = 'get_newsletter_statistics_overview',
  CreateAutomationEmail = 'create_automation_email',
  GetAutomationEmail = 'get_automation_email',
  GetAutomationEmailStatistics = 'get_automation_email_statistics',
  GetAutomationEmailStatisticsList = 'get_automation_email_statistics_list',
  GetAutomationEmails = 'get_automation_emails',
  UpdateAutomationEmail = 'update_automation_email',
  CreateAutomationEmailToSpecificAddress = 'create_automation_email_to_specific_address',
  GetAutomationEmailToSpecificAddress = 'get_automation_email_to_specific_address',
  GetAutomationEmailsToSpecificAddress = 'get_automation_emails_to_specific_address',
  UpdateAutomationEmailToSpecificAddress = 'update_automation_email_to_specific_address',
  ActivateWorkflow = 'activate_workflow',
  CreateWorkflow = 'create_workflow',
  DeactivateWorkflow = 'deactivate_workflow',
  GetWorkflow = 'get_workflow',
  GetWorkflows = 'get_workflows',
  CreateWorkflowStep = 'create_workflow_step',
  DeleteWorkflowStep = 'delete_workflow_step',
  GetWorkflowSteps = 'get_workflow_steps',
  UpdateWorkflowStep = 'update_workflow_step',
  CreateFunnel = 'create_funnel',
  CreateFunnelStep = 'create_funnel_step',
  DescribeFunnelPageSchema = 'describe_funnel_page_schema',
  DescribeFunnels = 'describe_funnels',
  GetFunnel = 'get_funnel',
  GetFunnelStep = 'get_funnel_step',
  GetFunnelSteps = 'get_funnel_steps',
  GetFunnels = 'get_funnels',
  SearchFunnelSteps = 'search_funnel_steps',
  DescribePageContentGuide = 'describe_page_content_guide',
  DescribePageEditGuide = 'describe_page_edit_guide',
  DescribePageSchema = 'describe_page_schema',
  DescribePageTemplate = 'describe_page_template',
  GetPageEditableContent = 'get_page_editable_content',
  SaveContent = 'save_content',
  SaveFunnelPageContent = 'save_funnel_page_content',
  SavePageContentFromTemplate = 'save_page_content_from_template',
  UpdatePageContent = 'update_page_content',
  GetDomains = 'get_domains',
  GetFiles = 'get_files',
  CreateCalendarAvailability = 'create_calendar_availability',
  CreateCalendarEvent = 'create_calendar_event',
  DeleteCalendarEvent = 'delete_calendar_event',
  GetBookingCalendarBookings = 'get_booking_calendar_bookings',
  GetBookingCalendarEvents = 'get_booking_calendar_events',
  GetCalendarAvailability = 'get_calendar_availability',
  GetCalendarEvent = 'get_calendar_event',
  UpdateCalendarAvailability = 'update_calendar_availability',
  UpdateCalendarEvent = 'update_calendar_event',
  GetSmsMessageServices = 'get_sms_message_services',
  GetSmsPhoneNumbers = 'get_sms_phone_numbers',
  CreateSmsTemplate = 'create_sms_template',
  DeleteSmsTemplate = 'delete_sms_template',
  GetSmsTemplate = 'get_sms_template',
  GetSmsTemplates = 'get_sms_templates',
  UpdateSmsTemplate = 'update_sms_template',
  ActivateCourse = 'activate_course',
  ActivateLecture = 'activate_lecture',
  CreateClassicCourse = 'create_classic_course',
  CreateClassicLecture = 'create_classic_lecture',
  CreateCourseModule = 'create_course_module',
  DeactivateCourse = 'deactivate_course',
  DeactivateLecture = 'deactivate_lecture',
  DeleteCourse = 'delete_course',
  DeleteCourseModule = 'delete_course_module',
  DeleteLecture = 'delete_lecture',
  DescribeCourses = 'describe_courses',
  GetCourse = 'get_course',
  GetCourseLectures = 'get_course_lectures',
  GetCourseModule = 'get_course_module',
  GetCourseModules = 'get_course_modules',
  GetCourses = 'get_courses',
  GetLecture = 'get_lecture',
  UpdateClassicCourse = 'update_classic_course',
  UpdateClassicLecture = 'update_classic_lecture',
  UpdateCourseModule = 'update_course_module',
  GetCourseThemes = 'get_course_themes',
  DescribePayment = 'describe_payment',
  CreateCoupon = 'create_coupon',
  DeleteCoupon = 'delete_coupon',
  GetCoupon = 'get_coupon',
  GetCoupons = 'get_coupons',
  UpdateCoupon = 'update_coupon',
  CreatePricePlan = 'create_price_plan',
  DeletePricePlan = 'delete_price_plan',
  GetPricePlan = 'get_price_plan',
  GetPricePlans = 'get_price_plans',
  UpdatePricePlan = 'update_price_plan',
  CreateDigitalProduct = 'create_digital_product',
  DeleteDigitalProduct = 'delete_digital_product',
  GetDigitalProduct = 'get_digital_product',
  GetDigitalProducts = 'get_digital_products',
  UpdateDigitalProduct = 'update_digital_product',
  CreatePhysicalProduct = 'create_physical_product',
  DeletePhysicalProduct = 'delete_physical_product',
  GetPhysicalProduct = 'get_physical_product',
  GetPhysicalProducts = 'get_physical_products',
  UpdatePhysicalProduct = 'update_physical_product',
  CreateOffer = 'create_offer',
  GetOffer = 'get_offer',
  UpdateOffer = 'update_offer',
  GetAvailablePaymentMethods = 'get_available_payment_methods',
  GetSaleSettings = 'get_sale_settings',
  UpdateSaleSettings = 'update_sale_settings',
}

export type McpTools = Record<
  McpToolName,
  {
    input: McpToolInput
    output: McpToolOutput
  }
>
